import { createSlice } from '@reduxjs/toolkit';
import {
  clearLocalStorage,
  persistLocalStorage,
} from '../../utilities/localstorage.utility';

export const EmptyUserApiState = {
  success: false,
  token: null,
};

export const UserKey = 'utility_api';

export const UtilityApiSlice = createSlice({
  name: 'utility_api',
  initialState: localStorage.getItem('utility_api')
    ? JSON.parse(localStorage.getItem('utility_api'))
    : EmptyUserApiState,
  reducers: {
    createCredentials: (state, action) => {
      persistLocalStorage(UserKey, action.payload);
      return action.payload;
    },
    updateCredentials: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(UserKey, result);
      return { ...state, ...action.payload };
    },
    resetCredentials: () => {
      clearLocalStorage(UserKey);
      return EmptyUserApiState;
    },
  },
});

export const { createCredentials, updateCredentials, resetCredentials } =
  UtilityApiSlice.actions;
